import { defineMessages } from "react-intl";

const baseId = "t.components.modals.SecurityQuestionsModal.";

export default defineMessages({
  SecurityQuestionsModalTitle: {
    id: baseId + "SecurityQuestionsModalTitle",
    defaultMessage: "SecurityQuestionsModalTitle",
  },
  SecurityQuestionsModalDesc: {
    id: baseId + "SecurityQuestionsModalDesc",
    defaultMessage: "Answer these security questions",
  },
  SecurityQuestionsModalClose: {
    id: baseId + "SecurityQuestionsModalClose",
    defaultMessage: "CLOSE",
  },
  SecurityQuestionsModalConfirm: {
    id: baseId + "SecurityQuestionsModalConfirm",
    defaultMessage: "CONFIRM",
  },
  SecurityQuestionsModalConfirmUser: {
    id: baseId + "SecurityQuestionsModalConfirmUser",
    defaultMessage: "GET QUESTIONS",
  },
  UserCodeModalLabel: {
    id: "t.components.modals.OTPModal.OTPUserCodeModalLabel",
    defaultMessage: "User Code",
  },
  errorAnswers: {
    id: baseId + "errorAnswers",
    defaultMessage: "ERROR",
  },
  errorAnswersContent: {
    id: baseId + "errorAnswersContent",
    defaultMessage: "ERROR MSG",
  },
  noQuestionsFound: {
    id: baseId + "noQuestionsFound",
    defaultMessage: "No questions found",
  },
});
